<template>
  <div id="voter-ct" v-if="status != -1">
    <!-- 老师 -->
    <div id="voter" class="voter-teacher" v-if="!student_type">
      <!-- 初始化 -->
      <div class="voter-init" v-if="status == 2">
        <i class="close" @click="close"></i>
        <p class="lamp-title">创建投票</p>
        <div class="lamp-scroll">
          <div class="title-ct">
            <span class="sign"></span>
            <span class="title-label">投票标题</span>
            <el-input
              type="text"
              placeholder="请输入"
              v-model="title"
              maxlength="20"
              show-word-limit
            >
            </el-input>
          </div>
          <div class="title-ct">
            <span class="title-label">投票说明</span>
            <el-input
              type="text"
              placeholder="请输入"
              v-model="titleIntro"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </div>
          <div class="choose-type">
            <div class="choose-type-ct">
              <span class="choose-title">选择方式</span>
              <el-radio v-model="radio" label="1">单选</el-radio>
              <el-radio v-model="radio" label="2">多选</el-radio>
              <div class="select" v-if="radio == 2">
                <span>最多选择</span>
                <el-select v-model="value" placeholder="请选择">
                  <el-option
                    v-if="item.value != 1"
                    v-for="item in chooseTextArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <span>项</span>
              </div>
            </div>

            <div class="choose-item-ct">
              <div
                class="choose-item"
                v-for="(chooseValue, index) in chooseTextArr"
              >
                <div class="title-ct">
                  <span class="title-label"
                    >选项{{ numToZn(index + 1, 1) }}</span
                  >
                  <el-input
                    type="text"
                    placeholder="请输入"
                    v-model="chooseValue['value' + (index + 1)]"
                    maxlength="20"
                    show-word-limit
                  >
                  </el-input>
                  <div
                    class="add-delete"
                    v-if="index == chooseTextArr.length - 1"
                  >
                    <i
                      class="add"
                      @click="addChoose"
                      v-if="index + 1 != maxCount"
                    ></i>
                    <i
                      class="delete"
                      @click="deleteChoose"
                      v-if="
                        (index + 1 != 2 && radio == 1) ||
                        (index + 1 != 2 && radio == 2)
                      "
                    ></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="voter-privaty">
            <span>投票隐私</span>
            <el-radio v-model="privatyType" label="1">公开</el-radio>
            <el-radio v-model="privatyType" label="2">匿名</el-radio>
          </div>

          <div class="voter-privaty">
            <span>投票结果</span>
            <el-radio v-model="resultType" label="1">投票后可见</el-radio>
            <el-radio v-model="resultType" label="2">截止后可见</el-radio>
            <i class="tips"></i>
            <span class="reult-intro">投票已截止才可查看投票结果</span>
          </div>
          <div class="sure-close">
            <span class="close-button" @click="close">取消</span>
            <span class="sure-button" @click="saveInit">发布</span>
          </div>
        </div>
      </div>
      <!-- 投票进行中 -->
      <div
        class="voter-save"
        v-if="(status == 1 || status == 0) && !detail_status"
      >
        <i class="close" @click="close"></i>
        <p class="lamp-title">投票器</p>
        <div class="save-title">
          <span class="item">{{ data.data.title }}</span>
          <span class="max-choose"
            >最多选择{{
              data.data.type == 2 ? data.data.max_select_num : 1
            }}项</span
          >
          <span class="status" v-if="status == 1">进行中</span>
          <span class="status end-status" v-if="status == 0">已结束</span>
          <span class="anonymous" v-if="data.data.privacy == 2">匿名</span>
        </div>
        <div class="save-intro">
          {{ data.data.desc }}
        </div>
        <div class="save-date">
          发布于：{{ data.data.create_at }}
          <span class="alear-count">
            {{ data.data.voter_student_count }}人已投：已投{{
              data.data.voter_count
            }}票
          </span>
        </div>
        <!-- 投票后可见 -->
        <div class="save-choose-ct" v-if="data.data.result == 1">
          <div
            class="save-choose-item"
            v-for="(value, index) in data.data.options"
          >
            <div class="left">
              {{ value.value }}
              <el-progress
                :percentage="value.rate"
                :show-text="false"
              ></el-progress>
              <i
                class="ranking"
                :class="'ranking-' + value.rank_number"
                v-if="status == 0"
              ></i>
            </div>
            <div class="right">
              <span
                class="count"
                :class="{ 'count-active': data.data.privacy == 1 }"
                @click="check(value)"
                >{{ value.count }}票</span
              >
              <span class="precent">{{ value.rate }}%</span>
            </div>
          </div>
        </div>
        <!-- 截止后可见 -->
        <div class="save-choose-ct" v-if="data.data.result == 2">
          <div
            class="save-choose-item"
            :class="{ 'privacy-active': status == 1 }"
            v-for="(value, index) in data.data.options"
          >
            <div class="left">
              {{ value.value }}
              <el-progress
                v-if="status == 0"
                :percentage="value.rate"
                :show-text="false"
              ></el-progress>
              <i
                class="ranking"
                :class="'ranking-' + value.rank_number"
                v-if="status == 0"
              ></i>
            </div>
            <div class="right" v-if="status == 0">
              <span
                class="count"
                :class="{
                  'count-active': status == 0 && data.data.privacy == 1,
                }"
                @click="check(value)"
                >{{ value.count }}票</span
              >
              <span class="precent">{{ value.rate }}%</span>
            </div>
          </div>
        </div>

        <div class="sure-close">
          <span class="close-button" @click="createVoter">创建投票</span>
          <span class="sure-button" v-if="status == 1" @click="endVoter"
            >结束投票</span
          >
        </div>
      </div>
      <!-- 投票详情 -->
      <div
        class="voter-detail"
        v-if="(status == 1 || status == 0) && detail_status"
      >
        <i class="close" @click="close"></i>
        <p class="lamp-title">投票详情</p>
        <div class="save-title">
          <span class="item">选项：{{ detail_data.value }}</span>
          <span class="alear-count"> {{ detail_data.count }}人已投 </span>
        </div>
        <div class="detail-ct" v-for="(value, index) in detail_data.details">
          <span>{{ value.student.real_name }}、</span>
        </div>
        <div class="detail-close">
          <span @click="closeDetail">返回</span>
        </div>
      </div>
    </div>

    <!-- 学生 -->
    <div id="voter" class="voter-student" v-if="student_type">
      <div class="voter-student-cover" v-if="!data.data.options">
        老师暂无发布投票
      </div>
      <div class="voter-student-choose" v-if="!detail_status">
        <i class="close" @click="close" v-if="!student_is_detail"></i>
        <p class="lamp-title">投票器</p>
        <div class="save-title">
          <span class="item">{{ data.data.title }}</span>
          <!-- <span class="max-choose">最多选择{{data.data.type == 2 ?data.data.max_select_num : 1}}项</span> -->
          <span class="status" v-if="status == 1">进行中</span>
          <span class="status end-status" v-if="status == 0">已结束</span>
          <span class="anonymous" v-if="data.data.privacy == 2">匿名</span>
        </div>
        <div
          class="save-intro"
          :class="{ 'save-intro-active': student_is_detail }"
        >
          {{ data.data.desc }}
          <span
            class="student-click-detail"
            @click="studentClickDetail"
            v-if="!student_is_detail"
            >详情</span
          >
        </div>
        <div class="save-date">
          <span class="max-choose"
            >最多选{{
              data.data.type == 2 ? data.data.max_select_num : 1
            }}项</span
          >
          <span class="publish" v-if="data.data.create_at"
            >发布于：{{ data.data.create_at.split(" ")[0] }}</span
          >
          <!-- <span class="alear-count">
	        		{{data.data.voter_student_count}}人已投
	        	</span> -->
        </div>
        <div class="student-choose-ct" v-if="!student_is_detail">
          <div
            class="item"
            :class="{
              'item-active': studentChooseArr.includes(value.id),
              'item-active-alr': student_is_voter,
            }"
            v-for="(value, index) in data.data.options"
            @click="studentChoose(value)"
          >
            <span>{{ value.value }}</span>
            <i class="choose-style"></i>
            <i class="choose-style-item"></i>
            <div
              class="choose-result"
              v-if="
                (data.data.result == 1 && student_is_voter) ||
                data.data.is_open == 0
              "
            >
              <span
                :class="{ 'count-active': data.data.privacy == 1 }"
                @click="check(value)"
                >{{ value.count }}票</span
              >
              <span>{{ value.rate }}%</span>
            </div>
            <i
              class="ranking"
              :class="'ranking-' + value.rank_number"
              v-if="status == 0"
            ></i>
          </div>
        </div>
        <div
          class="student-submit"
          v-if="
            !student_is_voter && !student_is_detail && data.data.is_open == 1
          "
        >
          <span @click="studentSubmit">提交</span>
        </div>
        <div class="student-submit back-detail" v-if="student_is_detail">
          <span @click="backDetail">返回投票</span>
        </div>
      </div>

      <!-- 投票详情 -->
      <div
        class="voter-detail"
        v-if="(status == 1 || status == 0) && detail_status"
      >
        <!-- <i class="close" @click="close"></i> -->
        <p class="lamp-title">投票详情</p>
        <div class="save-title">
          <span class="item">选项：{{ detail_data.value }}</span>
        </div>
        <div class="alear-count-student">{{ detail_data.count }}票</div>
        <div class="detail-ct" v-for="(value, index) in detail_data.details">
          <span>{{ value.student.real_name }}、</span>
        </div>
        <div class="detail-close student-detail-close">
          <span @click="closeDetail">返回</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStuBookScreen } from "./indexApi";
import { isBadWords } from "@/api/commonApi";
export default {
  name: "voter-ct",
  data() {
    return {
      //显示状态
      status: -1,
      //是否显示信号灯
      show: true,
      //是否为学生类型
      student_type: false,
      //更新组件key
      key: 0,
      //result数据
      data: null,
      //学生选中类型
      studentChooseType: 0,
      //学生是否已经投票
      studentFinish: false,
      //投票标题
      title: "",
      //投票说明
      titleIntro: "",
      //单选/多选
      radio: "1",
      //投票隐私类型
      privatyType: "1",
      //投票结果
      resultType: "2",
      //选择value(object)
      chooseTextArr: [
        {
          value1: "",
          value: "1",
          label: "1",
        },
        {
          value2: "",
          value: "2",
          label: "2",
        },
        {
          value3: "",
          value: "3",
          label: "3",
        },
      ],
      //最多选择项
      value: "2",
      //最多添加到
      maxCount: 20,
      //是否是详情状态
      detail_status: false,
      //详情数据
      detail_data: null,
      //学生选择选项
      studentChooseArr: [],
      //学生是否已经投票
      student_is_voter: false,
      //学生是否显示详情
      student_is_detail: false,
      //投票器id(学生使用)
      voter_id: -1,
      has_send_msg: false,
    };
  },
  watch: {
    receData(val) {
      if (this.student_type && !this.has_send_msg && val.data.is_window_open) {
        this.has_send_msg = true;
        this.$flydata.flydataTrack(260); //投票器埋点
      }
      console.log(val);
      this.detailEvent(val);
    },
    title(val) {
      console.log(val);
      this.title = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, "");
    },
    titleIntro(val) {
      console.log(val);
      this.titleIntro = val.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\_]/g, "");
    },
    chooseTextArrString(val) {
      this.chooseTextArr = JSON.parse(val);
      for (let [index, value] of this.chooseTextArr.entries()) {
        value["value" + (index + 1)] = value["value" + (index + 1)].replace(
          /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\_]/g,
          ""
        );
      }
    },
  },
  computed: {
    receData() {
      return this.$store.state.interaction.voter_Receive;
    },
    chooseTextArrString() {
      return JSON.stringify(this.chooseTextArr);
    },
  },
  methods: {
    backDetail() {
      this.student_is_detail = false;
    },
    studentClickDetail() {
      this.student_is_detail = true;
    },
    studentSubmit() {
      if (this.studentChooseArr.length == 0) {
        this.$toast("请投票");
        return;
      }
      this.$store.commit("sendvoterdataevent", this.studentChooseArr);
      this.$store.commit("sendvoterevent", this.key + "&event_voter_vote");
      this.key++;
    },
    studentChoose(value) {
      if (this.student_is_voter || this.data.data.is_open != 1) {
        return;
      }
      console.log(this.studentChooseArr.indexOf(value.id));
      let count = this.data.data.type != 1 ? this.data.data.max_select_num : 1;
      if (this.studentChooseArr.indexOf(value.id) > -1) {
        this.studentChooseArr.splice(
          this.studentChooseArr.indexOf(value.id),
          1
        );
        return;
      }
      if (this.studentChooseArr.length == count) {
        if (count == 1) {
          this.studentChooseArr.pop();
          this.studentChooseArr.push(value.id);
          return;
        }
        this.$toast(`只能选择${count}项`, 100);
        return;
      }
      this.studentChooseArr.push(value.id);
      console.log(this.studentChooseArr);
    },
    initData() {
      this.title = "";
      this.titleIntro = "";
      this.radio = "1";
      this.privatyType = "1";
      this.resultType = "2";
      this.chooseTextArr = [
        {
          value1: "",
          value: "1",
          label: "1",
        },
        {
          value2: "",
          value: "2",
          label: "2",
        },
        {
          value3: "",
          value: "3",
          label: "3",
        },
      ];
    },
    createVoter() {
      this.$store.commit("sendvoterevent", this.key + "&event_voter_create");
      this.key++;
      this.$nextTick(() => {
        $("#voter").height("5.78rem");
      });
    },
    closeDetail() {
      this.detail_status = false;
    },
    check(value) {
      if (this.data.data.privacy == 2) {
        console.log("公开才可查看");
        return;
      }
      this.$nextTick(() => {
        $("#voter").height($("#voter").height());
        console.log($("#voter").height());
      });
      this.detail_status = true;
      this.detail_data = value;
    },
    addChoose() {
      let count = (this.chooseTextArr.length + 1).toString();
      // if(arr == "21"){
      // 	this.$toast("最多选项最多为20");
      // 	return;
      // }
      let obj = {
        value: count,
        label: count,
      };
      obj["value" + count] = "";
      this.chooseTextArr.push(obj);
    },
    deleteChoose() {
      // if(this.chooseTextArr.length == 1){
      // 	this.$toast("至少保留一个选项");
      // 	return;
      // }
      this.chooseTextArr.pop();
      if (parseInt(this.value) > this.chooseTextArr.length) {
        this.value = this.chooseTextArr.length.toString();
      }
    },
    checkSentive(name) {
      return new Promise((resolve, reject) => {
        let data = {
          words: name,
        };
        isBadWords(data)
          .then((res) => {
            if (res.errCode == 0) {
              resolve(res.data.status);
            } else {
              this.$message(res.msg);
            }
          })
          .catch((err) => {
            throw new Error(err);
          });
      });
    },
    async saveInit() {
      let arr = [];
      let count = 0;
      for (let [index, value] of this.chooseTextArr.entries()) {
        arr.push(value["value" + (index + 1)]);
        if (value["value" + (index + 1)] != "") {
          count++;
        }
      }
      if (this.title == "") {
        this.$toast("投票标题不能为空");
        return;
      }
      if (count != this.chooseTextArr.length) {
        this.$toast("选项内容不能为空");
        return;
      }
      let senTiveWord = _.cloneDeep(arr);
      senTiveWord.push(this.title);
      senTiveWord.push(this.titleIntro);
      let result = await this.checkSentive(senTiveWord);
      if (result) {
        this.$message.error("存在敏感词汇");
        return;
      }
      let send_obj = {
        class_id: this.$cookies.get("class_id"),
        title: this.title,
        desc: this.titleIntro,
        type: this.radio,
        max_select_num: this.value,
        privacy: this.privatyType,
        result: this.resultType,
        options: arr,
      };
      console.log(send_obj);
      this.$store.commit("sendvoterevent", this.key + "&event_voter_publish");
      this.key++;
      this.$store.commit("sendvoterdataevent", send_obj);
      this.key++;
      this.$flydata.flydataTrack(250); //投票器埋点
      this.initData();
    },
    close() {
      this.status = -1;
      this.key = Math.random();
      this.$store.commit("sendvoterevent", this.key + "&event_voter_close");
      // this.key++;
      // this.initData();
      Object.assign(this.$data, this.$options.data());
      if (this.student_type && this.has_send_msg) {
        this.has_send_msg = false;
      }
    },
    endVoter() {
      this.$store.commit("sendvoterevent", this.key + "&event_voter_stop");
      this.key++;
    },
    studentResutlInit(val) {
      if (this.student_type) {
        if (this.voter_id != val.data.id) {
          this.student_is_voter = false;
          this.studentChooseArr = [];
        }
        this.voter_id = val.data.id;
        for (let value of val.data.voter_students) {
          if (value.user_id == this.$cookies.get("user_id")) {
            this.student_is_voter = true;
            for (let value_item of value.details) {
              this.studentChooseArr.push(value_item.voter_option_id);
            }
          }
        }
      }
    },
    detailEvent(val) {
      if (
        val.data.teacher_id &&
        this.$cookies.get("user_type") == this.identity.teacher
      ) {
        if (this.$cookies.get("user_id") != val.data.teacher_id) {
          console.log("不是该老师操作");
          return;
        }
      }
      this.init(val);
      // if(!this.student_type){
      // 	if(!val.data.is_teacher_click){
      // 		this.status = -1;
      // 	}else if(val.data.is_teacher_click_create){
      // 		this.status = 2;
      // 	}else{
      // 		this.status = val.data.is_open;
      // 	}
      // }else{
      // 	if(val.data.click_studentIds.includes(this.$cookies.get("user_id"))){
      // 		this.status = val.data.is_open;
      // 	}else{
      // 		this.status = -1;
      // 	}
      // 	// this.student_is_voter = false;
      // 	// this.studentChooseArr = [];
      // }
      if (val.data.is_window_open) {
        this.status = val.data.is_open;
      } else {
        this.status = -1;
      }

      //status 状态 -1:关闭投票器 0:结束 1:投票中 2:初始化
      console.log("#################################");
      console.log(this.status);
      switch (this.status) {
        case -1:
          console.log("-1-1-1-1-1-1");
          break;
        case 0:
          console.log("00000");
          // if(this.student_type){
          // 	for(let value of val.data.voter_students){
          // 		if(value.user_id == this.$cookies.get("user_id")){
          // 			this.student_is_voter = true;
          // 			for(let value_item of value.details){
          // 				this.studentChooseArr.push(value_item.voter_option_id)
          // 			}
          // 		}
          // 	}
          // }
          this.studentResutlInit(val);
          break;
        case 1:
          // if(this.student_type){
          // 	for(let value of val.data.voter_students){
          // 		if(value.user_id == this.$cookies.get("user_id")){
          // 			this.student_is_voter = true;
          // 			for(let value_item of value.details){
          // 				this.studentChooseArr.push(value_item.voter_option_id)
          // 			}
          // 		}
          // 	}
          // }
          this.studentResutlInit(val);
          console.log("11111");
          break;
        case 2:
          console.log("22222");
          break;
        case 3:
          console.log("333333");
          break;
        case 4:
          console.log("444444");
          break;
        default:
          console.log("信号灯返回结果没有匹配");
          break;
      }
    },
    init(val) {
      this.student_type =
        this.identity.student == this.$cookies.get("user_type") ? true : false;
      if (this.key > 10) {
        this.key = 0;
      }
      this.data = val;
    },
  },
  created() {},
  components: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
#voter-ct {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1998;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba($color: #000000, $alpha: 0.2);
  .voter-student {
    width: 4rem;
    min-height: 4.02rem;
    height: auto;
    padding-left: 0.16rem;
    .voter-student-cover {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      background-color: #fff;
      width: 100%;
      height: calc(100% - 0.5rem);
      bottom: 0;
    }
    .detail-ct {
      width: 3.72rem !important;
    }
    .alear-count-student {
      margin-bottom: 0.1rem;
    }
    .lamp-title {
      margin-top: 0.16rem;
      margin-bottom: 0.1rem;
      font-size: 0.16rem;
    }
    .save-title {
      margin-top: 0;
      margin-bottom: 0.1rem !important;
    }
    .publish {
      float: right;
      margin-right: 0.16rem;
    }
    .status {
      margin-right: 0.16rem !important;
    }
    .save-intro {
      width: calc(100% - 0.16rem);
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding-right: 0;
      padding-right: 0.35rem;
      .student-click-detail {
        position: absolute;
        right: 0;
        font-size: 0.15rem;
        cursor: pointer;
        color: #037bfe;
      }
    }
    .student-choose-ct {
      margin-top: 0.16rem;
      height: 2.08rem;
      overflow: auto;
      .item {
        // display: flex;
        // align-items: center;
        position: relative;
        width: 3.68rem;
        min-height: 0.4rem;
        // line-height: 0.4rem;
        font-size: 0.15rem;
        color: rgba(0, 0, 0, 0.87);
        background: #f3f6f9;
        border-radius: 0.03rem;
        margin-bottom: 0.16rem;
        padding-left: 0.1rem;
        border: 0.01rem solid #fff;
        padding: 0.1rem 0.1rem;
        .choose-result {
          font-size: 0.13rem;
          color: #037bfe;
          margin-top: 0.08rem;
          span {
            margin-right: 0.17rem;
          }
          .count-active {
            border-bottom: 1px solid #037bfe;
            cursor: pointer;
          }
        }
        .ranking {
          position: absolute;
          right: 0.08rem;
          top: 0.08rem;
          display: inline-block;
          width: 0.24rem;
          height: 0.24rem;
          margin-left: 0.08rem;
        }
        .ranking-1 {
          background: url("../../assets/images/medal_1.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .ranking-2 {
          background: url("../../assets/images/medal_2.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .ranking-3 {
          background: url("../../assets/images/medal_3.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
      }
      .item-active {
        position: relative;
        background: #eafffa;
        border: 0.01rem solid #44d7b6;
        .choose-style {
          position: absolute;
          right: -0.01rem;
          top: -0.01rem;
          display: inline-block;
          width: 0;
          height: 0;
          border-top: 0.16rem solid #44d7b6;
          border-left: 0.16rem solid transparent;
          background: url("../../assets/images/tick_ico (1).svg") no-repeat
            center center;
          background-size: 100% 100%;
        }
        .choose-style-item {
          position: absolute;
          right: 0rem;
          top: 0;
          display: inline-block;
          width: 0.07rem;
          height: 0.07rem;
          background: url("../../assets/images/tick_ico (1).svg") no-repeat
            center center;
          background-size: 100% 100%;
        }
      }
      .item-active.item-active-alr {
        background: #f3f6f9;
        border: 0.01rem solid #037bfe;
        .choose-style {
          border-top: 0.16rem solid #037bfe;
        }
        .choose-style-item {
        }
      }
    }
    .student-submit {
      width: 100%;
      text-align: center;
      margin: 0.24rem 0 0.24rem 0;
      span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 0.13rem;
        color: #ffffff;
        width: 0.63rem;
        height: 0.29rem;
        background: #027bfe;
        cursor: pointer;
        border-radius: 0.03rem;
      }
    }
    .back-detail {
      position: absolute;
      bottom: 0;
      left: 0;
    }
  }
}
#voter {
  position: absolute;
  // overflow: auto;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: 8.46rem;
  // height:5.78rem;
  min-height: 5.16rem;
  padding-left: 0.3rem;
  z-index: 1999;
  background: #fff;
  /deep/.el-radio__input.is-checked + .el-radio__label {
    font-weight: bold;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: inline-block;
    width: 0.5rem;
    height: 0.5rem;
    background: url("../../assets/images/close_ico_2.svg") no-repeat center
      center;
  }
  .lamp-title {
    font-weight: bold;
    font-size: 0.18rem;
    color: #202020;
    margin-top: 0.24rem;
    margin-bottom: 0.24rem;
  }
  .lamp-scroll {
    overflow: auto;
    padding-left: 0.12rem;
    margin-left: -0.12rem;
    // height: 5rem;
    height: 5.15rem;
  }
  .title-ct {
    margin-top: 0.24rem;
    position: relative;
    .sign {
      position: absolute;
      left: -0.12rem;
      top: 0.12rem;
      display: inline-block;
      width: 0.1rem;
      height: 0.1rem;
      background: url("../../assets/images/sign_ico_1.svg") no-repeat center
        center;
      // font-size: 0.24rem;
      // color: #FF004E;
    }
  }
  .title-ct:first-child {
    margin-top: 0;
  }
  .el-input {
    width: calc(100% - 1.2rem);
    height: 0.36rem;
  }
  /deep/.el-input--suffix .el-input__inner {
    width: 0.97rem;
  }
  /deep/.el-input__inner {
    height: 0.36rem;
    padding-right: 0.62rem;
  }
  .title-label {
    margin-right: 0.16rem;
    font-size: 0.16rem;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }
  .choose-type-ct {
    height: 0.4rem;
    display: flex;
    align-items: center;
  }
  .choose-type {
    margin-top: 0.2rem;
    margin-bottom: 0.29rem;
  }
  .choose-title {
    margin-right: 0.16rem;
    font-size: 0.16rem;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
  }
  .select {
    display: inline-block;
    select {
      width: 0.97rem;
      height: 0.36rem;
    }
    span {
      margin-right: 0.12rem;
      margin-left: 0.12rem;
    }
  }
  .choose-item-ct {
    // min-height: 1.48rem;
  }
  .choose-item {
    // padding-left:0.12rem;
    .title-ct {
      display: flex;
      align-items: center;
      margin-top: 0.2rem;
    }
    .title-label {
      width: 0.68rem;
      text-align: right;
    }
    .el-input {
      width: calc(100% - 1.88rem);
    }
  }
  .add-delete {
    display: inline-block;
    i {
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      cursor: pointer;
      margin-left: 0.16rem;
    }
    .add {
      background: url("../../assets/images/icon_upload_default copy 2.svg")
        no-repeat center center;
      background-size: 100% 100%;
    }
    .delete {
      background: url("../../assets/images/icon_upload_default copy 4.svg")
        no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .voter-privaty {
    display: flex;
    align-items: center;
    margin-bottom: 0.24rem;
    span {
      margin-right: 0.16rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
    .tips {
      display: inline-block;
      width: 0.2rem;
      height: 0.2rem;
      margin-right: 0.08rem;
      margin-left: -20px;
      background: url("../../assets/images/tips_ico.svg") no-repeat center
        center;
      background-size: 100% 100%;
    }
    .reult-intro {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 1.88rem;
      height: 0.25rem;
      font-size: 0.12rem;
      color: #475669;
      background: #f3f6f9;
    }
  }
  .sure-close {
    padding-top: 0.08rem;
    padding-right: 0.24rem;
    margin-bottom: 0.18rem;
    text-align: right;
    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 0.65rem;
      height: 0.32rem;
      cursor: pointer;
      font-size: 0.15rem;
      border-radius: 0.03rem;
    }
    .sure-button {
      background: #027bfe;
      font-weight: 500;
      color: #ffffff;
    }
    .close-button {
      background: #fafafa;
      color: #475669;
      margin-right: 0.16rem;
      border: 0.01rem solid #c0ccda;
    }
  }
  .save-title {
    margin-top: 0.22rem;
    .item {
      font-size: 0.18rem;
      font-weight: bold;
      display: inline-block;
      color: #000000;
      word-break: break-all;
      margin-right: 0.16rem;
      max-width: calc(100% - 0.8rem);
    }
    .max-choose {
      font-size: 0.16rem;
      color: #666666;
    }
    .anonymous {
      float: right;
      display: inline-block;
      width: 0.36rem;
      height: 0.24rem;
      text-align: center;
      line-height: 0.24rem;
      background: rgba(3, 123, 254, 0.05);
      border-radius: 0.03rem;
      border: 0.01rem solid rgba(3, 123, 254, 0.2);
      font-size: 0.12rem;
      color: #027bfe;
      margin-right: 0.3rem;
    }
    .status {
      float: right;
      display: inline-block;
      width: 0.48rem;
      height: 0.24rem;
      text-align: center;
      line-height: 0.24rem;
      background: rgba(19, 194, 194, 0.05);
      border-radius: 0.03rem;
      font-size: 0.12rem;
      color: #13c2c2;
      border: 0.01rem solid rgba(19, 194, 194, 0.2);
      margin-right: 0.4rem;
    }
    .end-status {
      width: 0.48rem;
      height: 0.24rem;
      background: #f5f5f5;
      border-radius: 0.03rem;
      border: 0.01rem solid #d9d9d9;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .save-intro {
    margin-top: 0.13rem;
    font-size: 0.16rem;
    padding-right: 0.4rem;
    color: #000000;
    word-break: break-all;
    max-height: 0.68rem;
  }
  .save-intro-active {
    max-height: 2rem !important;
    white-space: initial !important;
  }
  .save-date {
    margin-top: 0.1rem;
    font-size: 0.16rem;
    color: #666666;
  }
  .alear-count {
    float: right;
    font-size: 0.16rem;
    color: #666666;
    margin-right: 0.4rem;
  }
  .save-choose-ct {
    margin-top: 0.25rem;
    width: 100%;
    height: 3rem;
    overflow: auto;
    .save-choose-item {
      position: relative;
      width: calc(100% - 0.4rem);
      height: 0.48rem;
      background: #f3f6f9;
      border-radius: 0.03rem;
      margin-bottom: 0.25rem;
      .left {
        position: relative;
        display: inline-flex;
        align-items: center;
        padding-left: 0.1rem;
        height: 100%;
        line-height: 0.48rem;
        width: calc(100% - 1.36rem);
        background: #eef2f6;
        font-size: 0.16rem;
        color: rgba(0, 0, 0, 0.87);
        .ranking {
          display: inline-block;
          width: 0.24rem;
          height: 0.24rem;
          margin-left: 0.08rem;
        }
        .ranking-1 {
          background: url("../../assets/images/medal_1.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .ranking-2 {
          background: url("../../assets/images/medal_2.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
        .ranking-3 {
          background: url("../../assets/images/medal_3.svg") no-repeat center
            center;
          background-size: 100% 100%;
        }
      }
      .right {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 1.36rem;
        font-size: 0.16rem;
        color: #037bfe;
        .count {
          margin-right: 0.16rem;
        }
        .count-active {
          border-bottom: 1px solid #037bfe;
          cursor: pointer;
        }
        .precent {
        }
      }
      .el-progress {
        position: absolute;
        left: 0rem;
        bottom: 0rem;
        width: 100%;
      }
    }
    .privacy-active {
      background: #eef2f6;
    }
  }
  .sure-close {
    margin-bottom: 0.24rem;
    span {
      display: inline-block;
      width: 0.88rem;
      line-height: 0.32rem;
      text-align: center;
      height: 0.32rem;
      font-size: 0.15rem;
    }
    .sure-button {
    }
    .close-button {
      background: #fafafa;
      border: 0.01rem solid #037bfe;
      color: #037bfe;
    }
  }
  .voter-detail {
    // position: relative;
    .save-title {
      margin-bottom: 0.22rem;
    }
    .detail-ct {
      width: 7.76rem;
      min-height: 0.54rem;
      max-height: 3.6rem;
      overflow: auto;
      line-height: 0.54rem;
      padding: 0 0.16rem;
      background: #f3f6f9;
      border-radius: 0.03rem;
      word-break: keep-all;
      span {
        font-size: 0.16rem;
        color: rgba(0, 0, 0, 0.87);
      }
    }
    .detail-close {
      width: 100%;
      position: absolute;
      right: 0.25rem;
      bottom: 0.25rem;
      text-align: right;
      span {
        display: inline-block;
        width: 0.65rem;
        height: 0.32rem;
        text-align: center;
        line-height: 0.32rem;
        font-size: 0.15rem;
        color: #475669;
        background: #fafafa;
        cursor: pointer;
        border: 0.01rem solid #c0ccda;
      }
    }
    .student-detail-close {
      text-align: center;
      left: 0;
      right: 0;
      span {
        width: 0.63rem;
        height: 0.28rem;
        line-height: 0.28rem;
        background: #027bfe;
        color: #ffffff;
        border-radius: 0.03rem;
      }
    }
  }
}
@media screen and (max-width: 846px) {
  .voter-teacher {
    width: 5.46rem !important;
    .lamp-tools {
      margin-bottom: 0.24rem !important;
    }
  }
}
@media screen and (max-height: 560px) {
  #voter.voter-teacher {
    height: 4.5rem !important;
    min-height: 4rem;
    // min-height: auto !important;
    .lamp-scroll {
      height: 3rem;
    }
    .save-choose-ct {
      height: 1.5rem;
    }
  }
  #voter-ct .voter-student .student-choose-ct {
    height: 1.84rem;
  }
}
</style>
